"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deduplicateTimelineItems = exports.extractAllTwaeLists = exports.extractTwaeListsFromNode = void 0;
function extractTwaeListsFromNode(node) {
    var _a;
    let out = [];
    if ((_a = node.settings) === null || _a === void 0 ? void 0 : _a.twae_list) {
        out = out.concat(node.settings.twae_list);
    }
    if (Array.isArray(node.elements)) {
        node.elements.forEach((child) => {
            out = out.concat(extractTwaeListsFromNode(child));
        });
    }
    return out;
}
exports.extractTwaeListsFromNode = extractTwaeListsFromNode;
function extractAllTwaeLists(timelineRoot) {
    if (!Array.isArray(timelineRoot.content))
        return [];
    const all = timelineRoot.content
        .map((chunk) => extractTwaeListsFromNode(chunk))
        .reduce((a, b) => a.concat(b), []);
    return deduplicateTimelineItems(all);
}
exports.extractAllTwaeLists = extractAllTwaeLists;
function deduplicateTimelineItems(items) {
    var _a;
    const seen = new Set();
    const result = [];
    for (const item of items) {
        const key = `${item === null || item === void 0 ? void 0 : item.twae_date_label}-${(_a = item === null || item === void 0 ? void 0 : item.twae_description) === null || _a === void 0 ? void 0 : _a.substring(0, 50)}`;
        if (!seen.has(key)) {
            seen.add(key);
            result.push(item);
        }
    }
    return result;
}
exports.deduplicateTimelineItems = deduplicateTimelineItems;
